/* eslint-disable class-methods-use-this */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable react/require-default-props */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import bindMethods from 'auto-bind';
import Mousetrap from 'mousetrap';
import isEmpty from 'lodash/isEmpty';

import VideoPlayer from './VideoPlayer';
import Overlay from '../Overlay';
import { videoJsOptions } from '../../constants/videoJsOptions';
import { DARK_GREY } from '../../constants/theme';
import {
  PAUSE_PLAY,
  ONE_FRAME_BACK,
  ONE_FRAME_FORWARD,
  ALT_PAUSE_PLAY,
  REWIND_FIVE_SECONDS,
  FAST_FORWARD_FIVE_SECONDS,
  EXTEND_OUT,
} from '../../constants/hotKeys';
import { addVideojsOptions } from '../../state/videoContent';
import {
  getVirtualClipperPlayerInstance,
  togglePause,
  oneSecondForward,
  oneSecondBack,
  oneFrameBack,
  oneFrameForward,
  fiveSecondsBack,
  fiveSecondsForward,
} from '../../utils/videojs';
import { extendLastEditiedClip } from '../../state/clipList';

export const VIDEO_CONTENT_ID = 'VideoContent';

const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background-color: ${DARK_GREY};
  position: relative;
`;

class VideoContent extends PureComponent {
  constructor(props) {
    super(props);
    this.keyboardOneFrameBack = ONE_FRAME_BACK;
    this.keyboardOneFrameForward = ONE_FRAME_FORWARD;
    this.keyboardPausePlay = PAUSE_PLAY;
    this.keyboardAltPausePlay = ALT_PAUSE_PLAY;
    this.keyboardFiveSecBack = REWIND_FIVE_SECONDS;
    this.keyboardFiveSecForward = FAST_FORWARD_FIVE_SECONDS;
    this.keyboardExtendOut = EXTEND_OUT;
    this.shiftArrowRightHandlers = this.createShiftHandlers('ArrowRight', oneSecondForward);
    this.shiftArrowLeftHandlers = this.createShiftHandlers('ArrowLeft', oneSecondBack);

    bindMethods(this);
  }

  componentDidMount() {
    const { addVideojsOptions, extendLastEditiedClip } = this.props;
    this.shiftExtendOutHandlers = this.createShiftHandlers(this.keyboardExtendOut, extendLastEditiedClip);

    addVideojsOptions(videoJsOptions);
    this.bindHotKeys();
  }

  componentDidUpdate() {
    const { isKeyboardControlsEnabled } = this.props;
    const isClipActivePlaying = this.isClipActivePlaying();

    if (!isKeyboardControlsEnabled || isClipActivePlaying) {
      this.unbindHotKeys();
    }

    if (isKeyboardControlsEnabled && !isClipActivePlaying) {
      this.bindHotKeys();
    }
  }

  componentWillUnmount() {
    this.unbindHotKeys();
  }

  createShiftHandlers(code, onPress) {
    let isArrowPressed = false;

    function onKeyDown(e) {
      if (e.code === code && e.shiftKey && !isArrowPressed) {
        onPress();
        isArrowPressed = true;
      }
    }

    function onKeyUp(e) {
      if (e.code === code && e.shiftKey) {
        isArrowPressed = false;
      }
    }

    return {
      onKeyDown,
      onKeyUp,
    };
  }

  bindShiftArrowHandlers(arrow) {
    document.addEventListener('keydown', this[`shift${arrow}Handlers`].onKeyDown, false);
    document.addEventListener('keyup', this[`shift${arrow}Handlers`].onKeyUp, false);
  }

  unbindShiftArrowHandlers(arrow) {
    document.removeEventListener('keydown', this[`shift${arrow}Handlers`].onKeyDown, false);
    document.removeEventListener('keyup', this[`shift${arrow}Handlers`].onKeyUp, false);
  }

  bindShiftExtend() {
    document.addEventListener('keydown', this.shiftExtendOutHandlers.onKeyDown, false);
    document.addEventListener('keyup', this.shiftExtendOutHandlers.onKeyUp, false);
  }

  unbindShiftExtend() {
    document.removeEventListener('keydown', this.shiftExtendOutHandlers.onKeyDown, false);
    document.removeEventListener('keyup', this.shiftExtendOutHandlers.onKeyUp, false);
  }

  bindHotKeys() {
    this.bindShiftArrowHandlers('ArrowRight');
    this.bindShiftArrowHandlers('ArrowLeft');
    this.bindShiftExtend();
    Mousetrap.bind(this.keyboardOneFrameBack, oneFrameBack);
    Mousetrap.bind(this.keyboardOneFrameForward, oneFrameForward);
    Mousetrap.bind(this.keyboardPausePlay, togglePause);
    Mousetrap.bind(this.keyboardAltPausePlay, togglePause);
    Mousetrap.bind(this.keyboardFiveSecBack, fiveSecondsBack);
    Mousetrap.bind(this.keyboardFiveSecForward, fiveSecondsForward);
    console.log('[QA] hotkey binded');
  }

  unbindHotKeys() {
    this.unbindShiftArrowHandlers('ArrowRight');
    this.unbindShiftArrowHandlers('ArrowLeft');
    this.unbindShiftExtend();
    Mousetrap.unbind(this.keyboardOneFrameBack);
    Mousetrap.unbind(this.keyboardOneFrameForward);
    Mousetrap.unbind(this.keyboardPausePlay);
    Mousetrap.unbind(this.keyboardAltPausePlay);
    Mousetrap.unbind(this.keyboardFiveSecBack);
    Mousetrap.unbind(this.keyboardFiveSecForward);
    console.log('[QA] hotkey unbinded');
  }

  isClipActivePlaying() {
    const {
      currentPlayingClip: { index: playingIndex },
      currentReviewingClip: { index: reviewingIndex },
    } = this.props;

    return playingIndex !== null || reviewingIndex !== null;
  }

  render() {
    const isClipActivePlaying = this.isClipActivePlaying();

    return (
      <Container id={VIDEO_CONTENT_ID}>
        <VideoPlayer {...videoJsOptions} />
        <Overlay isInvisible={!isClipActivePlaying} />
      </Container>
    );
  }
}

VideoContent.propTypes = {
  isPlayerReady: PropTypes.bool.isRequired, // supplied from Redux
  addVideojsOptions: PropTypes.func.isRequired, // supplied from Redux
  currentPlayingClip: PropTypes.object.isRequired, // supplied from Redux
  currentReviewingClip: PropTypes.object.isRequired, // supplied from Redux
  videoSources: PropTypes.object.isRequired, // supplied from Redux
  isKeyboardControlsEnabled: PropTypes.bool, // supplied from Redux
  extendLastEditiedClip: PropTypes.func.isRequired, // supplied from Redux
};

const mapStateToProps = (state) => ({
  isPlayerReady: state.videoPlayer.isReady,
  currentPlayingClip: state.currentPlayingClip,
  currentReviewingClip: state.currentReviewingClip,
  videoSources: state.videoSources,
  isKeyboardControlsEnabled: state.videoPlayer.isKeyboardControlsEnabled,
});

const mapDispatchToProps = {
  addVideojsOptions,
  extendLastEditiedClip,
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoContent);
